<template>
  <div class="cp-backoffice-article-detail-view bg-grey">
    <div class="cp-backoffice-article-detail-view-breadcrumbs-container">
      <Breadcrumbs />
    </div>

    <div class="cp-backoffice-article-detail-view-container bg-white">
      <ValidationObserver ref="observer">
        <p class="title is-5">{{ $t('backoffice.articles.detail.title') }}</p>
        <ValidationProvider
          slim
          rules="required"
          :name="$t('backoffice.articles.detail.input.title')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            label="Header"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="title"></b-input>
          </b-field>
        </ValidationProvider>

        <!-- <ValidationProvider
          slim
          rules=""
          :name="$t('backoffice.articles.detail.input.title.en')"
          v-slot="{ errors }"
        >
          <b-field
            :label="$t('backoffice.articles.detail.input.title.en')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="title_en"></b-input>
          </b-field>
        </ValidationProvider> -->

        <ValidationProvider
          slim
          rules="required"
          :name="$t('backoffice.articles.detail.input.excerpt')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            label="Intro"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="prefix"></b-input>
          </b-field>
        </ValidationProvider>

        <!-- <ValidationProvider
          slim
          rules=""
          :name="$t('backoffice.articles.detail.input.excerpt.en')"
          v-slot="{ errors }"
        >
          <b-field
            :label="$t('backoffice.articles.detail.input.excerpt.en')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="prefix_en"></b-input>
          </b-field>
        </ValidationProvider> -->

        <ValidationProvider
          slim
          rules="required"
          :name="$t('backoffice.articles.detail.input.content')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            label="Content"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <Quill v-model="content" />
          </b-field>
        </ValidationProvider>

        <!-- <ValidationProvider
          slim
          rules=""
          :name="$t('backoffice.articles.detail.input.content.en')"
          v-slot="{ errors }"
        >
          <b-field
            :label="$t('backoffice.articles.detail.input.content.en')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <Quill v-model="content_en" />
          </b-field>
        </ValidationProvider> -->

        <!-- <b-field :label="$t('backoffice.articles.detail.input.featured')">
          <b-switch v-model="enabledFeatured"></b-switch>
        </b-field> -->

        <!-- <ValidationProvider
          slim
          rules=""
          :name="$t('backoffice.articles.detail.input.category')"
          v-slot="{ errors }"
        >
          <b-field
            :label="$t('backoffice.articles.detail.input.category')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <Multiselect
              v-model="selectedCategories"
              placeholder=""
              label="category_name"
              track-by="id"
              :options="allCategories"
              :multiple="true"
              :taggable="true"
            />
          </b-field>
        </ValidationProvider> -->

        <!-- <p class="title is-5">{{ $t('backoffice.articles.detail.cover.image.title') }}</p> -->

        <ValidationProvider
          slim
          rules="required"
          :name="$t('backoffice.articles.detail.cover.image.title')"
          v-slot="{ errors }"
        >
          <b-field
            :label="$t('backoffice.articles.detail.cover.image.title')"
            horizontal
            v-model="cover_image" :type="errors[0] ? 'is-danger' : ''" :message="errors[0]">
            <Upload :url="cover_image" @add-image="setCoverImage" @change-image="setCoverImage" />
          </b-field>
        </ValidationProvider>
      </ValidationObserver>

      <br />

      <b-button
        class="cp-backoffice-article-detail-view-save-button"
        type="is-primary"
        rounded
        :disabled="disabled"
        :loading="saveLoading"
        @click="save"
        >{{ $t('backoffice.common.save.label') }}</b-button
      >
      <b-button
        class="cp-backoffice-article-detail-view-delete-button"
        type="is-danger"
        outlined
        rounded
        :disabled="disabled || !$route.params.id"
        :loading="deleteLoading"
        @click="cancel"
        >{{ $t('backoffice.common.delete.label') }}</b-button
      >
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/backoffice/Breadcrumbs.vue';
import ConfirmModal from '@/components/backoffice/ConfirmModal.vue';
// import Multiselect from 'vue-multiselect';
import Upload from '@/components/backoffice/Upload.vue';
import Quill from '@/components/Quill/Quill.vue';
import { removeArticle, updateArticle, createArticle, getArticle } from '@/apis/article';
import { getCategories } from '@/apis/category';

export default {
  name: 'ArticleDetailView',
  components: {
    Breadcrumbs,
    Quill,
    Upload,
  },
  data() {
    return {
      allCategories: [],
      selectedCategories: [],
      category_id: [],
      title: '',
      title_en: '',
      prefix: '',
      prefix_en: '',
      content: '',
      content_en: '',
      cover_image: '',
      enabledFeatured: false,
      featured: 'no',
      saveLoading: false,
      deleteLoading: false,
      uploadLoading: false,
      disabled: false,
    };
  },
  watch: {
    enabledFeatured() {
      this.featured = this.enabledFeatured ? 'yes' : 'no';
    },
    selectedCategories() {
      this.category_id = this.selectedCategories.map(item => item.id);
    },
  },
  async mounted() {
    const loading = this.$buefy.loading.open();

    try {
      const { categories } = await getCategories(1, 9999);
      this.allCategories = categories;

      if (!this.$route.params.id) {
        return;
      }

      const article = await getArticle(this.$route.params.id);

      this.title = article.title;
      this.title_en = article.title_en;
      this.prefix = article.prefix;
      this.prefix_en = article.prefix_en;
      this.content = article.content;
      this.content_en = article.content_en;
      this.cover_image = article.cover_image;
      this.enabledFeatured = article.featured === 'yes';
      this.featured = article.featured;
      this.category_id = article.category_id || [];

      this.selectedCategories = categories.filter(item => this.category_id.includes(item.id));
    } catch (error) {
      this.$buefy.snackbar.open({
        message: this.$t('backoffice.common.fetch.fail'),
        type: 'is-danger',
        position: 'is-top',
        actionText: this.$t('snackbar.ok.text'),
        duration: 2000,
      });

      this.disabled = true;
      this.$sentry.captureException(error);
    } finally {
      loading.close();
    }
  },
  methods: {
    async save() {
      const success = await this.$refs.observer.validate();

      if (!success) {
        return;
      }

      this.saveLoading = true;

      try {
        const data = {
          title: this.title,
          title_en: this.title_en,
          prefix: this.prefix,
          prefix_en: this.prefix_en,
          content: this.content,
          content_en: this.content_en,
          cover_image: this.cover_image,
          featured: this.featured,
          category_id: this.category_id,
        };

        if (!this.$route.params.id) {
          await createArticle(data);
        } else {
          await updateArticle(this.$route.params.id, data);
        }

        this.$buefy.snackbar.open({
          message: this.$t('backoffice.articles.save.success'),
          type: 'is-success',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 2000,
        });

        this.$router.push({
          name: 'BackofficeArticleList',
        });
      } catch (error) {
        this.$buefy.snackbar.open({
          message: this.$t('backoffice.articles.save.fail'),
          type: 'is-danger',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 2000,
        });

        this.$sentry.captureException(error);
      } finally {
        this.saveLoading = false;
      }
    },
    cancel() {
      this.$buefy.modal.open({
        parent: this,
        component: ConfirmModal,
        props: {
          title: this.$t('backoffice.articles.modal.delete.title'),
          ok: this.$t('backoffice.articles.modal.delete.ok'),
          cancel: this.$t('backoffice.articles.modal.delete.cancel'),
        },
        events: {
          ok: this.removeArticle,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async removeArticle() {
      this.deleteLoading = true;

      try {
        await removeArticle(this.$route.params.id);

        this.$buefy.snackbar.open({
          message: this.$t('backoffice.articles.delete.success'),
          type: 'is-success',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 2000,
        });

        this.$router.push({
          name: 'BackofficeArticleList',
        });
      } catch (error) {
        this.$buefy.snackbar.open({
          message: this.$t('backoffice.articles.delete.fail'),
          type: 'is-danger',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 2000,
        });

        this.$sentry.captureException(error);
      } finally {
        this.deleteLoading = false;
      }
    },
    setCoverImage(url) {
      this.cover_image = url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.bg-grey{
  background-color:#f2f2f2 ;
}
.bg-white{
  background-color: white;
}

.cp-backoffice-article-detail-view {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;

  &-container {
    flex-grow: 1;
    border: 1px solid #cacaca;
    padding: 40px;
  }

  &-save-button {
    width: 100px;
  }

  &-delete-button {
    width: 100px;
    margin-left: 10px;
  }
}
</style>
